import { MENU_KEY_ROUTES } from "src/constants";
import { DiscountsDetails, DiscountsListing } from "src/Modules/Discounts/pages";

export const discountsRoutes = {
  path: MENU_KEY_ROUTES["Discounts"],
  children: [
    {
      index:true,
      element: <DiscountsListing/>,
    },
    {
      path:":code",
      element:<DiscountsDetails/>
    }
  ],
};